import React from "react";
import Slider from "react-slick";
import "./ImageSlider.css"; // Optional for custom styling
import history from "../media/tourism/Vijaygarh Fort/fort1.jpeg";  // Import the image
import forest from "../media/tourism/Biodiversity Park/park2.jpg"; 
import waterfall from "../media/tourism/Mukha fall/fall5.jpg"; 
import temple from "../media/tourism/Renukeshwar Mandir/mandir1.jpeg"; 
import wild from "../media/tourism/Slider image/wild.jpg";
import religious from "../media/tourism/Slider image/Best Religious tour (1).png";
import varanasi from "../media/tourism/Slider image/Best Religious tour (2).png";
import kumbh from "../media/tourism/Slider image/Best Religious tour (3).png";
import son from "../media/tourism/Slider image/Best Religious tour (7).png"
import { Link } from "react-router-dom";

const ImageSlider = () => {
  const images = [
    { src:  varanasi, caption: "" },
    { src:  kumbh, caption: "" },
    { src:  religious, caption: "" },
    { src:  son, caption: "" },
    // { src: waterfall, caption: "Beautiful Waterfalls" },
    // { src:  forest, caption: "Mountains & Forests" },
    // { src:  history, caption: "Historical Sites" },
    // { src:  wild, caption: "Wildlife Sanctuary" },
  ];

  const settings = {
    dots: true,
    infinite: true,
    speed: 800,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 2000,
    arrows: false, // Remove navigation arrows
  };

  return (
    <div className="slider-container">
      <Link to="/article" style={{ textDecoration: 'none' }}>
        <h2 className="slider-heading">Place of Mankind Origin</h2>
      </Link> 
      {/* <h2 className="slider-headingbelow">What We Got</h2> */}
      <Slider {...settings}>
        {images.map((image, index) => (
          <div key={index} className="slider-item">
            <img src={image.src} alt={image.caption} className="slider-image" />
            <p className="slider-caption">{image.caption}</p>
          </div>
        ))}
      </Slider>
    </div>
  );
};

export default ImageSlider;
